<template>
  <div class="border-b mt-4 pb-2">
    <div class="ml-4 xl:ml-8 mr-7">
      <div class="b-2 xl:mb-0 flex items-start">
        <button
          type="button"
          class="flex"
          title="View customer info"
          @click.prevent="openCustomerInfoModal"
        >
          <!-- <svg-vue icon="avatar" title="Profile" class="w-6 h-6 inline-block mr-2 default-avatar-icon" /> -->
          <img
            v-show="!showingDefaultAvatar"
            @load="showingDefaultAvater = false"
            :src="customer.avatar_uri"
            class="w-6 h-6 z-0 mr-2 rounded-full outline:none hover:cursor-default default-avatar-icon"
          />
          <svg-vue
            v-show="showingDefaultAvatar"
            icon="circle-user"
            title="default user avatar"
            class="h-6 mr-2 hover:cursor-pointer"
          />
          <div class="text-hint md:text-base font-bold">
            {{ customer.display_name }}
          </div>
        </button>
      </div>
    </div>
    <div class="flex items-center ml-12">
      <svg-vue
        icon="salesium-logo-plain"
        class="h-4 w-4 mr-1 fill-black mt-0.5"
      />
      <a class="md:text-base text-hint" @click.prevent="ping">Ping</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showingDefaultAvatar: true
    }
  },
  props: ["customer"],
  methods: {
    openCustomerInfoModal() {
      // this.$emit("openCustomerModal", this.customer);
    },
    ping() {
      this.$emit("openPingModal", this.customer);
    },
  },
};
</script>
